import { Box, Typography, Grid, Button } from '@mui/material';
import { ProgramTypeCard } from './ProgramTypeCard';
import { useMemberWord } from '../../../utils/memberTypeLabels';

export function ProgramLaunchPage({
  onPrevious,
  onSelectMasterclass,
  onSelectMentorship,
  onSelectGuidedMasterclass
}: {
  onPrevious: () => void;
  onSelectMasterclass: () => void;
  onSelectMentorship: () => void;
  onSelectGuidedMasterclass: () => void;
}) {
  const mentors = useMemberWord()('mentor', { plural: true, lower: true });
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Inter'
        // bgcolor: 'black'
      }}
    >
      {/* conteúdo principal */}
      <Box
        sx={{
          flex: 1,
          px: { xs: 3, sm: 5 },
          py: { xs: 6, sm: 10 },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 5
          }}
        >
          <Typography fontSize={18} fontWeight={700} color="#FDFDFD" textAlign="center">
            What type of program do you want to build?
          </Typography>

          <Grid container spacing={3} justifyContent="center">
            <Grid item>
              <ProgramTypeCard
                title="Course"
                description="A self-paced learning program built using your inputs and internal documents. Ideal for scalable, on-demand training that adapts to your documentation, goals, and learners."
                onSelect={onSelectMasterclass}
              />
            </Grid>

            <Grid item>
              <ProgramTypeCard
                title="Mentorship"
                description={`A lightweight development path powered by internal ${mentors}. Best for informal growth, knowledge sharing, or supporting individuals without structured content.`}
                onSelect={onSelectMentorship}
              />
            </Grid>

            <Grid item>
              <ProgramTypeCard
                title="Guided Course"
                description="A blended experience combining self-paced course content with scheduled human touchpoints."
                onSelect={onSelectGuidedMasterclass}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* footer */}
      <Box
        sx={{
          p: 3,
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Button
          onClick={onPrevious}
          sx={{
            backgroundColor: '#1C1C1C',
            borderRadius: '6px',
            color: '#FDFDFD',
            border: '1px solid #2A2A2A',
            textTransform: 'none',
            fontSize: 14,
            fontWeight: 500,
            px: 2.5,
            '&:hover': { backgroundColor: '#2b2b2b' }
          }}
        >
          Previous
        </Button>
      </Box>
    </Box>
  );
}
